import React from 'react';
import { Button } from './Button';
import { Icon } from './Icon';
import { useLanguage } from '../contexts/LanguageContext';
import { FANVUE_PROFILE_URL } from '../utils/fanvue';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="relative min-h-screen md:min-h-[85vh] flex items-center justify-center overflow-hidden" data-id="element-154" data-mp="9l34tdl96e4i">
      {/* Background Image - Editorial Visibility */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/9ouEXuUddZLUXEC3rRN8Jw/IMG_6003.JPG.jpg)'
    }} data-id="element-155" data-mp="128pixfs3x15m" />

      {/* Gradient Overlay - Left Side Only for Text Legibility */}
      {/* Right side stays clear to show the editorial image */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-transparent" data-id="element-156" data-mp="3d2l8r9xwn0zn" />

      {/* Subtle Bottom Gradient for Depth */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" data-id="element-157" data-mp="384s5oprwen3l" />

      {/* Very Subtle Top Vignette */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-transparent" data-id="element-158" data-mp="3o6kg9kdpcg66" />

      {/* Elegant Accent Line */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C5A028]/60 to-transparent" data-id="element-159" data-mp="39cflp2zjb5v3" />

      {/* Content - Positioned Left to Let Image Breathe */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 md:py-20 w-full" data-id="element-160" data-mp="30gq47517ivmz">
        <div className="max-w-2xl md:max-w-lg text-center md:text-left mx-auto md:mx-0" data-id="element-161" data-mp="359j9bu0l85zl">
          {/* Refined Badge */}
          <div className="inline-flex items-center gap-2 bg-black/50 backdrop-blur-sm border border-[#C5A028]/40 rounded-sm px-5 py-2.5 mb-6 animate-fade-in" data-id="element-162" data-mp="2qhqtlgwvspxc">
            <Icon name="crown" size={14} className="text-[#C5A028]" data-id="element-163" data-mp="2hk8522k13tgp" />
            <span className="text-white/90 text-xs font-medium tracking-[0.2em] uppercase" data-id="element-164" data-mp="2lkimqch6o8be">
              {t('hero.badge')}
            </span>
          </div>

          {/* Aspirational Headline */}
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white mb-5 tracking-tight leading-[1.1] animate-fade-in-delay-1 drop-shadow-lg" data-id="element-165" data-mp="nbl58stuaue5">
            {t('hero.title1')}
            <br data-id="element-166" data-mp="dd5c6kb95b20" />
            <span className="text-[#C5A028] italic" data-id="element-167" data-mp="ddf082cql852">{t('hero.title2')}</span>
          </h1>

          {/* Professional Subheadline */}
          <p className="text-base md:text-lg text-white/80 mb-6 font-light tracking-wide leading-relaxed max-w-md mx-auto md:mx-0 animate-fade-in-delay-2 drop-shadow-md" data-id="element-168" data-mp="1azkvlrn8ois7">
            {t('hero.subtitle')}
          </p>

          {/* Single Primary CTA */}
          <div className="animate-fade-in-delay-3 mb-8 flex justify-center md:justify-start" data-id="element-169" data-mp="x1eevoaf8zfr">
            <Button href={FANVUE_PROFILE_URL} className="text-sm w-full md:w-auto shadow-2xl shadow-[#C5A028]/30" data-id="element-170" data-mp="3lsypyre788fd">
              <span className="mr-2" data-id="element-171" data-mp="3hpsft8nytx3m">{t('hero.cta')}</span>
              <Icon name="arrow-right" size={16} data-id="element-172" data-mp="1x9ukg9uwtbmw" />
            </Button>
          </div>

          {/* Authority Indicators */}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-5 animate-fade-in-delay-4" data-id="element-173" data-mp="21bpm5fgr5r17">
            <div className="flex items-center gap-3 bg-black/30 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-174" data-mp="268odxrcy1lw8">
              <div className="w-9 h-9 rounded-full bg-[#C5A028]/20 border border-[#C5A028]/40 flex items-center justify-center" data-id="element-175" data-mp="2b2smug5rs3zy">
                <Icon name="star" size={16} className="text-[#C5A028]" data-id="element-176" data-mp="2kyn9dmd46j80" />
              </div>
              <div data-id="element-177" data-mp="2p0h7bmvxd94h">
                <p className="text-white text-sm font-medium leading-tight" data-id="element-178" data-mp="2ozz60bueo4pp">
                  +3M
                </p>
                <p className="text-white/60 text-xs leading-tight" data-id="element-179" data-mp="2tyir6a16dch0">
                  {t('hero.followers')}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-black/30 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-180" data-mp="zlaqi1qiq6ng">
              <div className="w-9 h-9 rounded-full bg-[#C5A028]/20 border border-[#C5A028]/40 flex items-center justify-center" data-id="element-181" data-mp="4aurcylqfdrh">
                <Icon name="camera" size={16} className="text-[#C5A028]" data-id="element-182" data-mp="3vgvtuirmsz1i" />
              </div>
              <div data-id="element-183" data-mp="e8innsyzktbr">
                <p className="text-white text-sm font-medium leading-tight" data-id="element-184" data-mp="e91wmk6ns7dn">
                  Editorial
                </p>
                <p className="text-white/60 text-xs leading-tight" data-id="element-185" data-mp="98mjntqah1w7">
                  {t('hero.professional')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Refined Scroll Indicator */}
      <div className="absolute bottom-8 md:bottom-10 left-1/2 -translate-x-1/2 animate-bounce" data-id="element-186" data-mp="3rh584tgyp93u">
        <div className="w-5 h-8 border border-white/30 rounded-full flex justify-center pt-1.5" data-id="element-187" data-mp="3mp3qst4xss6y">
          <div className="w-0.5 h-2 bg-white/50 rounded-full animate-pulse" data-id="element-188" data-mp="2yyznynzkowh0" />
        </div>
      </div>
    </section>;
}